import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTabsModule } from "@angular/material/tabs";


import { OOTTComponent } from "./oott/oott.component";
import { DetalleOOTTComponent } from "./detalle-oott/detalle-oott.component";
import { ListadoOOTTComponent } from "./oott/components/listado-oott/listado-oott.component";
import { DialogTicketComponent } from "./oott/components/dialog-ticket/dialog-ticket.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FichaOrdenTrabajoComponent } from "./detalle-oott/components/ficha-orden-trabajo/ficha-orden-trabajo.component";

import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatChipsModule } from "@angular/material/chips";
import { DialogAvanceTrabajoComponent } from "./detalle-oott/components/dialog-avance-trabajo/dialog-avance-trabajo.component";
import { ImagenesOOTTComponent } from "./detalle-oott/components/imagenes-oott/imagenes-oott.component";
import { DialogUbicacionComponent } from "./detalle-oott/components/dialog-ubicacion/dialog-ubicacion.component";
import { DialogRecibirComponent } from "./detalle-oott/components/dialog-recibir/dialog-recibir.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../shared/services/auth/role-guard.service";
import { DialogOoccComponent } from "./oott/components/dialog-oocc/dialog-oocc.component";
import { DialogContratistasComponent } from "./detalle-oott/components/dialog-contratistas/dialog-contratistas.component";
import { ListadoContratistasComponent } from "./detalle-oott/components/listado-contratistas/listado-contratistas.component";
import { ListadoInvitacionesContratistasComponent } from "./detalle-oott/components/listado-invitaciones-contratistas/listado-invitaciones-contratistas.component";
import { SharedModule } from "../shared/shared/shared.module";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DialogInvitarComponent } from "./detalle-oott/components/dialog-invitar/dialog-invitar.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatBadgeModule } from "@angular/material/badge";
import { DialogAnularTrabajoComponent } from "./detalle-oott/components/dialog-anular-trabajo/dialog-anular-trabajo.component";
import { DialogAsignarContratistaComponent } from "./detalle-oott/components/dialog-asignar-contratista/dialog-asignar-contratista.component";
import { FiltroOottComponent } from "./oott/components/filtro-oott/filtro-oott.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { DialogEvaluarComponent } from "./detalle-oott/components/dialog-evaluar/dialog-evaluar.component";
import { DialogCorregirComponent } from "./detalle-oott/components/dialog-corregir/dialog-corregir.component";
import { DialogPagoContratistaComponent } from "./detalle-oott/components/dialog-pago-contratista/dialog-pago-contratista.component";
import { IvyGalleryModule } from "angular-gallery";
import { DialogPersonalApoyoComponent } from './detalle-oott/components/dialog-personal-apoyo/dialog-personal-apoyo.component';
import { DialogInvitacionesComponent } from "./detalle-oott/components/dialog-invitaciones/dialog-invitaciones.component";
import { PipesModule } from "../shared/pipes/pipes.module";

const routes = [
    {
        path: "ordenes-de-trabajo",
        component: OOTTComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
    {
        path: "ordenes-de-trabajo/:idOOTT",
        component: DetalleOOTTComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
];

@NgModule({
    declarations: [
        OOTTComponent,
        DetalleOOTTComponent,
        ListadoOOTTComponent,
        DialogTicketComponent,
        FichaOrdenTrabajoComponent,
        DialogAvanceTrabajoComponent,
        ImagenesOOTTComponent,
        DialogUbicacionComponent,
        DialogRecibirComponent,
        DialogOoccComponent,
        DialogContratistasComponent,
        ListadoContratistasComponent,
        ListadoInvitacionesContratistasComponent,
        DialogInvitarComponent,
        DialogAnularTrabajoComponent,
        DialogAsignarContratistaComponent,
        FiltroOottComponent,
        DialogEvaluarComponent,
        DialogCorregirComponent,
        DialogPagoContratistaComponent,
        DialogPersonalApoyoComponent,
    
        

        DialogInvitacionesComponent,
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        RouterModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        MatInputModule,
        FuseSharedModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatToolbarModule,
        MatListModule,
        MatSelectModule,
        MatChipsModule,
        MatCheckboxModule,
        SharedModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatBadgeModule,
        MatTooltipModule,
        MatAutocompleteModule,
        IvyGalleryModule,
        PipesModule,
    ],
    entryComponents: [DialogTicketComponent],
})
export class OOTTModule {}
